export const SET_JOB_TITLE = "SET_JOB_TITLE";
export const SET_CAREER_CLUSTER = "SET_CAREER_CLUSTER";
export const SET_JOB_DESCRIPTION = "SET_JOB_DESCRIPTION";
export const SET_IS_GREEN = "SET_IS_GREEN";
export const SET_IS_BRIGHT = "SET_IS_BRIGHT";
export const SET_SKILL_LEVEL = "SET_SKILL_LEVEL";
export const SET_SEARCH_TYPE = "SET_SEARCH_TYPE";
export const SET_SELECTED_INDEX = "SET_SELECTED_INDEX";
export const SET_SHOW_SKILL_LEVELS = "SET_SHOW_SKILL_LEVELS";
export const SET_SELECTED_SKILL = "SET_SELECTED_SKILL";
export const SHOW_VIDEO_PLAYER = "SHOW_VIDEO_PLAYER";

export function setJobTitle(title) {
    return {
        type: SET_JOB_TITLE,
        payload: title,
    };
}

export function setCareerCluster(cluster) {
    return {
        type: SET_CAREER_CLUSTER,
        payload: cluster,
    };
}

export function setJobDescription(description) {
    return {
        type: SET_JOB_DESCRIPTION,
        payload: description,
    };
}

export function setIsGreen(is_green) {
    return {
        type: SET_IS_GREEN,
        payload: is_green ? 1 : 0,
    };
}

export function setIsBright(is_bright) {
    return {
        type: SET_IS_BRIGHT,
        payload: is_bright ? 1 : 0,
    };
}

export function setSkillLevel(key, level) {
    return {
        type: SET_SKILL_LEVEL,
        key,
        level,
    };
}

export function setSearchType(val) {
    return {
        type: SET_SEARCH_TYPE,
        val,
    };
}

export function setSelectedIndex(index) {
    return {
        type: SET_SELECTED_INDEX,
        index,
    };
}

export function setShowSkillLevels(show) {
    return {
        type: SET_SHOW_SKILL_LEVELS,
        show,
    };
}

export function setSelectedSkill(skill) {
    return {
        type: SET_SELECTED_SKILL,
        skill,
    };
}

export function showVideoPlayer(show) {
    return {
        type: SHOW_VIDEO_PLAYER,
        show,
    };
}
